var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"waitForT",rawName:"v-waitForT"}],staticClass:"foko-app"},[_c('foko-navigation'),_c('keep-alive',{attrs:{"include":"foko-objects,foko-map","exclude":"foko-object"}},[_c('router-view')],1),_c('colophon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }